import { render, staticRenderFns } from "./AllDemands.vue?vue&type=template&id=d8b25b12&scoped=true"
import script from "./AllDemands.vue?vue&type=script&lang=js"
export * from "./AllDemands.vue?vue&type=script&lang=js"
import style0 from "./AllDemands.vue?vue&type=style&index=0&id=d8b25b12&prod&lang=scss"
import style1 from "./AllDemands.vue?vue&type=style&index=1&id=d8b25b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b25b12",
  null
  
)

export default component.exports